import { buildAction } from 'store/actions/actionCreator'

import * as constants from './constants'

export const openSearch = buildAction(constants.OPEN_SEARCH)
export const closeSearch = buildAction(constants.CLOSE_SEARCH)

export const searchForStores = buildAction(constants.SEARCH_FOR_STORES)
export const searchForStoresLogic = buildAction(constants.SEARCH_FOR_STORES_LOGIC)
export const searchForStoresSuccess = buildAction(constants.SEARCH_FOR_STORES_SUCCESS, 'stores')
export const searchForStoresError = buildAction(constants.SEARCH_FOR_STORES_ERROR, 'error')

export const setSearchInputValue = buildAction(constants.SET_SEARCH_INPUT_VALUE, 'value')
export const startTyping = buildAction(constants.START_TYPING)
export const stopTyping = buildAction(constants.STOP_TYPING)

export const clearSelection = buildAction(constants.CLEAR_ALL)
export const toggleShowSelectedOnly = buildAction(constants.TOGGLE_SELECTED)
export const closeDetails = buildAction(constants.CLOSE_DETAILS)
export const toggleDetails = buildAction(constants.TOGGLE_DETAILS, 'store')
export const toggleItem = buildAction(constants.TOGGLE_ITEM, 'store')
